/**
 * Testimonials 1056 — KUK home student testimonials.
 * Portrait quote cards in `metadata`, on a scroll rail that dims every card
 * which is not (almost) fully in view.
 */

export const TESTIMONIALS_1056_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Testimonials",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_name: "",
    meta_designation: "",
    meta_quote: "",
    meta_priority: 1,
    meta_status: true,
  },

  TESTIMONIALS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Student Testimonials",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Student Testimonials",
      defaultValue: "Student Testimonials",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_1",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "The short accent bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "background_color",
      label: "Band background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_color",
      label: "Card fill from 768px up",
      value: "rgba(159, 28, 51, 0.1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(159, 28, 51, 0.1)",
      defaultValue: "rgba(159, 28, 51, 0.1)",
    },
    {
      fieldName: "mobile_background_color",
      label: "Card fill below 768px",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Quote mark colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_2",
      label: "Quote body colour",
      value: "#344054",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#344054",
    },
    {
      fieldName: "gradient_color_3",
      label: "Student name colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_4",
      label: "Designation colour",
      value: "#475467",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#475467",
    },
    {
      fieldName: "button_color",
      label: "Prev / next background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_text_color",
      label: "Prev / next glyph colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Previous icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the reference's ← glyph if empty",
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Previous icon alt",
      value: "Previous",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Previous",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Next icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the reference's → glyph if empty",
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Next icon alt",
      value: "Next",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Next",
    },
    {
      fieldName: "pre_title_color",
      label: "Dot colour — in view",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      description: "The position dots below 768px.",
      defaultValue: "#031F44",
    },
    {
      fieldName: "desktop_background_color",
      label: "Dot colour — out of view",
      value: "#6B7280",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#6B7280",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Photo",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload student photo",
      defaultValue: "",
    },
    {
      header: "Photo alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Name",
      fieldName: "meta_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Designation",
      fieldName: "meta_designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "MCA",
      defaultValue: "",
    },
    {
      header: "Quote",
      fieldName: "meta_quote",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
